import { formatDateForDisplay } from '../../accessibility-trends-chart/helpers/dateFormatHelpers';
import { CHART_TEXT } from '../constants';

/**
 * Creates tooltip HTML content for accessibility stacked chart
 */
export const createTooltipContent = (name: string, dateString: string, value: number): string => {
	const date = formatDateForDisplay(dateString);
	const label = `${name} issues`;
	return `<span class="tooltip-label">${label}</span>: ${value}</span><br/><span class="tooltip-date">${CHART_TEXT.TOOLTIP.DATE_LABEL} ${date}</span>`;
};
